var render = function () {
  var _class, _class2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.container] = true, _class[_vm.$style.active] = _vm.isActive, _class)
  }, [_c('div', {
    class: (_class2 = {}, _class2[_vm.$style.panel] = true, _class2[_vm.$style.disabled] = _vm.disabled, _class2),
    on: {
      "click": function click($event) {
        return _vm.$emit('click', false);
      }
    }
  }, [_vm.$slots.hasOwnProperty('icon') ? _c('div', {
    class: _vm.$style.icon,
    style: _vm.iconStyles
  }, [_vm._t("icon")], 2) : _vm._e(), _c('div', {
    class: _vm.$style.title
  }, [_vm.$slots.hasOwnProperty('title') ? [_vm._t("title")] : [_vm._v(" " + _vm._s(_vm.title) + " ")]], 2), _c('div', {
    class: _vm.$style.switcher,
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('click', true);
      }
    }
  }, [_c('cs-switcher', {
    attrs: {
      "value": _vm.value,
      "disabled": _vm.disabled
    }
  })], 1)]), _vm.isActive ? _c('div', {
    class: _vm.$style.content
  }, [_vm._t("content")], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }